export interface Testimonial {
  quote: string
  name: string
  role: string
  image: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'The biggest difference for me was having a process to follow. I no longer feel like I’m jumping randomly between different findings when evaluating a case.',
    name: 'Dr. Andrew R.',
    role: 'General Dentist — United States 🇺🇸',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/91701cb8-af06-4dd4-9d27-fe068ccc91f2.jpg',
  },
  {
    quote:
      'The decision trees make everything much easier to organize. Instead of trying to remember everything, I can follow the steps and make sure I’m not overlooking something important.',
    name: 'Dr. Emily G.',
    role: 'Dentist — United Kingdom 🇬🇧',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/afdead1a-0ea9-40fb-b2db-6240d790ad96.jpg',
  },
  {
    quote:
      'What I liked most is that it’s practical. The checklists and protocols are things I can actually use in my day-to-day practice.',
    name: 'Dr. Michael T.',
    role: 'General Dentist — Canada 🇨🇦',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c8e0c057-8ab0-41da-b854-529d5a9fd064.jpg',
  },
  {
    quote:
      'It helped me create a much more consistent approach to evaluating my patients. I finally have a framework I can use instead of relying entirely on intuition.',
    name: 'Dr. Daniela M.',
    role: 'Dentist — Australia 🇦🇺',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/de08e112-588a-4e1c-b55d-19bbcb986ddc.jpg',
  },
]

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'How will I receive the material?',
    answer:
      'Immediately after completing your purchase, you’ll receive an email with access to the complete digital library. You can download the materials and access them from your computer, tablet or mobile device.',
  },
  {
    question: 'Are the files downloadable?',
    answer:
      'Yes. The clinical library is delivered digitally, allowing you to download and keep the materials for future reference.',
  },
  {
    question: 'Is this a one-time payment?',
    answer:
      'Yes. You pay $27 USD once and receive lifetime access. There are no monthly subscriptions or recurring charges.',
  },
  {
    question: 'Is this suitable for general dentists?',
    answer:
      'Yes. The system is designed specifically for dentists and dental professionals who want a more structured approach to evaluating and diagnosing their cases.',
  },
  {
    question: 'Is this only for specialists?',
    answer:
      'No. General dentists can use the system to structure their everyday diagnostic process, while dentists dealing with more complex cases can use the protocols and decision frameworks as an additional clinical reference.',
  },
  {
    question: 'Do I need any specific software?',
    answer:
      'No. The system is designed as a clinical diagnostic framework and does not require specialized software.',
  },
  {
    question: 'Is this a live course?',
    answer:
      'No. It is a digital clinical library that you can access immediately and study at your own pace.',
  },
  {
    question: 'What if I don’t find it useful?',
    answer:
      'That’s exactly why we offer the 7-Day Guarantee. Go through the material and decide whether it fits your clinical workflow. If it doesn’t meet your expectations, contact us within 7 days for a full refund.',
  },
]

export const purchaseNotifications: { name: string; city: string }[] = [
  { name: 'Dr. Sarah W.', city: 'Austin, United States' },
  { name: 'Dr. James P.', city: 'Manchester, United Kingdom' },
  { name: 'Dr. Olivia B.', city: 'Toronto, Canada' },
  { name: 'Dr. Liam K.', city: 'Melbourne, Australia' },
  { name: 'Dr. Priya N.', city: 'Dublin, Ireland' },
  { name: 'Dr. Ethan C.', city: 'San Diego, United States' },
  { name: 'Dr. Grace H.', city: 'Auckland, New Zealand' },
  { name: 'Dr. Daniel F.', city: 'Cape Town, South Africa' },
  { name: 'Dr. Emma L.', city: 'Chicago, United States' },
  { name: 'Dr. Noah S.', city: 'Vancouver, Canada' },
]
